import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';
import { FaCheck } from 'react-icons/fa'

interface TipGroupProps {
  isSelected: boolean
}

interface AnalystContainerProps {
  color: string;
}

interface CheckProps {
  checked: boolean
}

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const MainBody = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const CalendarContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  padding: 2rem .3rem 0 2rem;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 12px;     
  }

  ::-webkit-scrollbar-track {
    background: #EEEEEE;    
    border-radius: 20px;       

  }

  ::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;    
    border-radius: 20px;       
    border: 3px solid #EEEEEE;  
  }
`;

export const Calendar = styled.div`
  width: 92%;
`;

export const Load = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
`;

export const Checkmark = styled(FaCheck) <CheckProps>`
  color: ${styleSheet.colorMain};
  display: ${({ checked }) => checked ? 'flex' : 'none'};
`;

export const Tips = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 3.5rem;
`;

export const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${styleSheet.shapeDark};
  margin-bottom: .5rem;
`;

export const TipGroup = styled.button<TipGroupProps>`
  display: flex;
  width: 120px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  padding: 5px 4px;
  /* border: 1px solid ${styleSheet.titleLight}; */
  /* border-radius: 6px; */

  color: ${styleSheet.shapeDark};
  font-weight: ${({ isSelected }) => isSelected ? 'bold' : 'normal'};
  font-size: ${({ isSelected }) => isSelected ? '1.6rem' : '1.4rem'};
`;

export const Tip = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.span`
  font-size: 1.2rem;
  margin-left: .3rem;
`;

export const Receive = styled.p`
  width: 100%;
  font-size: 2rem;
  font-weight: bold;
  border-top: 1px #ccc solid;
  padding-top: 1rem;
  margin-bottom: 1rem;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  z-index: 99;
`;

export const SelectAnalystContainer = styled.div`
  background-color: ${styleSheet.shape};
  display: block;
  position: fixed;
  width: 40%;
  height: auto;
  max-height: 60%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: black;
  border-radius: 5px;
  z-index: 999;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 12px;     
  }

  ::-webkit-scrollbar-track {
    background: #EEEEEE;    
    border-radius: 20px;       

  }

  ::-webkit-scrollbar-thumb {
    background-color: #CCCCCC;    
    border-radius: 20px;       
    border: 3px solid #EEEEEE;  
  }
`;

export const SelectAnalystContent = styled.div`
  padding: 3rem;
  display: flex;
  flex-wrap: wrap;
`;

export const AnalystContainer = styled.button<AnalystContainerProps>`
  padding: 1rem 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  margin-right: 2rem;
  background-color: ${({ color }) => color};
  border-radius: 5px;
  border: 0;
  cursor: pointer;
`;

export const AnalystName = styled.span`
  font-size: 1.6rem;
`;

export const DetailContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailText = styled.span`
  font-size: 1.4rem;
`;